import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0); // Scrolls to the top of the page when the route changes
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
